// Sound + desktop-notification helpers for incoming chat messages.
// Sound is synthesised with the Web Audio API (no asset to ship); the desktop
// notification uses the standard Notification API after the user grants it.

let audioCtx = null;

// A soft two-note "ping". Best-effort: browsers block audio until the user has
// interacted with the page, in which case this silently no-ops.
export function playChime() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    if (!audioCtx) audioCtx = new Ctx();
    const ctx = audioCtx;
    if (ctx.state === "suspended") ctx.resume();
    const now = ctx.currentTime;
    const notes = [
      [880, 0.0],
      [1320, 0.09],
    ];
    notes.forEach(([freq, at]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, now + at);
      gain.gain.exponentialRampToValueAtTime(0.18, now + at + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + at + 0.18);
      osc.connect(gain).connect(ctx.destination);
      osc.start(now + at);
      osc.stop(now + at + 0.2);
    });
  } catch (e) {
    /* ignore */
  }
}

// Ask for desktop-notification permission once (call on a user gesture).
export function ensureNotificationPermission() {
  try {
    if ("Notification" in window && Notification.permission === "default") {
      Notification.requestPermission().catch(() => {});
    }
  } catch (e) {
    /* ignore */
  }
}

// Show a desktop notification only when the tab is hidden/unfocused, so it
// doesn't double up with the in-app UI the user is already looking at.
export function showDesktopNotification(title, body, icon) {
  try {
    if (!("Notification" in window) || Notification.permission !== "granted") return;
    if (typeof document !== "undefined" && document.visibilityState === "visible" && document.hasFocus()) return;
    const n = new Notification(title, { body: (body || "").slice(0, 140), icon: icon || undefined });
    n.onclick = () => {
      window.focus();
      n.close();
    };
    setTimeout(() => n.close(), 6000);
  } catch (e) {
    /* ignore */
  }
}

// Convenience: alert for a new message (sound always; desktop when unfocused).
export function alertNewMessage(name, body, icon) {
  playChime();
  showDesktopNotification(name || "New message", body || "", icon);
}
